module.exports = __webpack_public_path__ + "img/download-green.e60a0276.svg";